export const SN_BANNERSLIDER = 'bannerslider'
export const BANNERSLIDER_UPDATE_BANNER = SN_BANNERSLIDER + '/UPDATE_BANNER'
export const BANNERSLIDER_ADD_BANNER = SN_BANNERSLIDER + '/ADD_BANNER'
export const BANNERSLIDER_SET_CURRENT = SN_BANNERSLIDER + '/SET_CURRENT'